import type { ReactNode } from "react";
import { Typo } from "@pepperstone/pepper-ui-kit";

export function SectionSubtitle({ children }: { children: ReactNode }) {
  return (
    <Typo elem="h3" type="heading" size="xs">
      {children}
    </Typo>
  );
}
